import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'marketing-checklist/:url',
  async getComponent (nextState) {
    const {
      default: MarketingChecklistContainer
    } = await import(/* webpackChunkName: "marketing-checklist" */ './containers/MarketingChecklistContainer.tsx')
      .catch(handleChunkLoadError);
    return MarketingChecklistContainer;
  },
  getData ({ context: { props } }) {
    return props;
  }
});
